var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChrome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#b7b7b7",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 24 4 C 17.78 4 12.230313 6.8292969 8.5703125 11.279297 L 14.369141 21.330078 C 15.549141 17.110078 19.41 14 24 14 L 41.310547 14 C 37.860547 8.02 31.4 4 24 4 z M 6.6796875 14.009766 C 4.9696875 16.949766 4 20.36 4 24 C 4 33.92 11.209453 42.150703 20.689453 43.720703 L 26.5 33.669922 C 25.7 33.879922 24.86 34 24 34 C 20.31 34 17.079609 31.980234 15.349609 28.990234 L 15.339844 29 L 6.6796875 14.009766 z M 24 17 A 7 7 0 1 0 24 31 A 7 7 0 1 0 24 17 z M 31.130859 17 C 32.900859 18.81 34 21.28 34 24 C 34 25.82 33.500391 27.520234 32.650391 28.990234 L 32.660156 29 L 24 44 C 35.05 44 44 35.05 44 24 C 44 21.54 43.550234 19.18 42.740234 17 L 31.130859 17 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChrome);
export default __webpack_public_path__ + "static/media/chrome.6369da3c6ebf237cb745ce31bd614589.svg";
export { ForwardRef as ReactComponent };